import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowRight, Gamepad2, Star } from 'lucide-react'
import SkinCarousel from '../components/SkinCarousel'
import TermsAndInfo from '../components/TermsAndInfo'
import Games from './Games'
import useAppStore from '../store/useAppStore'
import { HalloweenBanner } from '../features/event'

const GuestHome = () => {
  const { t } = useTranslation()
  const openLogin = useAppStore((state) => state.openLogin)

  return (
    <div className="pb-10 text-white">
      <div className="px-4 pt-5 lg:px-0 lg:pt-6">
        <section className="relative isolate overflow-hidden rounded-3xl border border-white/10 bg-surface shadow-[inset_0_1px_0_rgba(255,255,255,0.07),0_10px_15px_-3px_rgba(0,0,0,0.25),0_4px_6px_-4px_rgba(0,0,0,0.25)]">
          <div className="pointer-events-none absolute inset-y-0 right-0 w-full opacity-35 sm:w-3/4 lg:w-[58%] lg:opacity-100">
            <img src="/images/teams-banner.jpg" alt="" className="h-full w-full object-cover object-center" />
          </div>
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-surface via-surface/95 to-surface/50 lg:via-surface/85 lg:to-surface/10" />
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-surface/80 to-transparent" />
          <div className="relative flex min-h-[330px] flex-col justify-center px-6 py-12 sm:px-10 lg:min-h-[440px] lg:px-16 lg:py-16">
            
            <h1 className="max-w-2xl text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              {t('guest.heroTitle')}
            </h1>
            <p className="mt-5 max-w-lg text-sm leading-relaxed text-text-secondary sm:text-base lg:text-lg">
              {t('guest.heroDescription')}
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <button type="button" onClick={openLogin} className="gradient-border-cta inline-flex min-h-12 items-center justify-center gap-2 rounded-xl px-6 py-3 font-bold text-dark-primary transition-transform hover:scale-[1.02] active:scale-[0.98]">
                {t('guest.heroStart')}
                <ArrowRight size={18} className="rtl:rotate-180" />
              </button>
              <Link to="/teams" className="inline-flex min-h-12 items-center justify-center rounded-xl border border-white/15 bg-white/5 px-6 py-3 font-semibold text-white transition-colors hover:border-white/30 hover:bg-white/10">
                {t('guest.teams')}
              </Link>
            </div>
          </div>
        </section>
      </div>

      {/* Баннер эвента — появляется сам, только пока эвент идёт */}
      <div className="mx-auto mt-6 max-w-xl px-4 empty:hidden lg:mt-8 lg:px-0">
        <HalloweenBanner />
      </div>

      <section aria-label="Live" className="mt-8 lg:mt-10">
        <div className="flex items-center gap-2 px-4 text-xs font-bold uppercase tracking-[0.2em] text-info lg:px-0">
          <span className="h-1.5 w-1.5 rounded-full bg-info" />
          Live
        </div>
        <div className="mt-2">
          <SkinCarousel />
        </div>
      </section>

      <section className="mt-10 lg:mt-12" aria-labelledby="guest-games-title">
        <div className="flex items-center gap-3 px-4 lg:px-0">
          <Gamepad2 size={24} className="text-text-secondary" aria-hidden="true" />
          <h2 id="guest-games-title" className="text-2xl font-black uppercase tracking-tight sm:text-3xl">{t('nav.games')}</h2>
        </div>
        <div className="lg:-mx-4">
          <Games embedded />
        </div>
      </section>

      <section className="mt-12 px-4 lg:mt-16 lg:px-0" aria-label={t('guest.ratingLabel')}>
        <div className="flex justify-center" dir="ltr" aria-hidden="true">
          <div className="inline-flex items-center gap-4 rounded-full border border-amber-300/25 bg-amber-300/[0.07] px-5 py-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]">
            <span className="inline-flex shrink-0 items-center gap-0.5 text-amber-300">
              {Array.from({ length: 5 }, (_, index) => (
                <span key={index} className="relative inline-flex h-[17px] w-[17px] shrink-0">
                  {index === 4 && <Star size={17} strokeWidth={1.5} fill="currentColor" className="text-amber-300/25" />}
                  <span className={index === 4 ? 'absolute inset-0 w-4/5 overflow-hidden' : ''}>
                    <Star size={17} strokeWidth={1.5} fill="currentColor" />
                  </span>
                </span>
              ))}
            </span>
            <span className="h-5 w-px bg-amber-200/25" />
            <span className="inline-flex shrink-0 items-baseline whitespace-nowrap text-xl font-black leading-none tabular-nums text-amber-100">4.8<span className="ms-0.5 text-[0.55em] font-medium text-amber-200/55">/5</span></span>
          </div>
        </div>
        <div className="mx-auto mt-7 max-w-lg space-y-3 text-center text-base italic leading-relaxed text-text-secondary sm:text-lg">
          <blockquote>«<bdi dir="auto">{t('guest.quoteSkin')}</bdi>»</blockquote>
          <blockquote>«{t('guest.quoteWin')}»</blockquote>
          <blockquote>«{t('guest.quoteSupport')}»</blockquote>
        </div>
      </section>

      <div className="mt-8 lg:mt-10">
        <TermsAndInfo />
      </div>
    </div>
  )
}

export default GuestHome
